export default "__VITE_ASSET__CgXqXBiM__"